import { Box, Dialog, DialogContent } from "@mui/material";
import { useState } from "react";

import FormTemplateForm from "./FormTemplateForm";
import FormTemplateValuesDisplay from "./FormTemplateValuesDisplay";
import { Shared_FormTemplateFragment } from "./fragments/fragments.generated";

type Props = {
    form: Shared_FormTemplateFragment;
    disabled?: boolean;
    readOnly?: boolean;
    values: Record<string, string | null>;
    onChange: (values: Record<string, string | null>) => void;
};

export default function FormTemplateDialogEditor({ form, values, onChange, disabled, readOnly }: Props) {
    const [showForm, setShowForm] = useState(false);
    if (readOnly) return <FormTemplateValuesDisplay form={form} values={values} />;

    return (
        <>
            <Dialog open={showForm} onClose={() => setShowForm(false)} fullWidth maxWidth="sm">
                <DialogContent>
                    <FormTemplateForm
                        form={form}
                        values={values}
                        onChange={onChange}
                        disabled={disabled}
                        readOnly={readOnly}
                    />
                </DialogContent>
            </Dialog>

            <Box
                onClick={() => {
                    if (disabled) return;
                    setShowForm(true);
                }}
                sx={theme => ({
                    borderRadius: 1,
                    padding: 2,
                    backgroundColor: theme.palette.action.selected,
                    "&:hover": !disabled && { cursor: "pointer" },
                })}
            >
                <FormTemplateValuesDisplay form={form} values={values} />
            </Box>
        </>
    );
}
